import { useMutation, useQuery, useQueryClient } from "@tanstack/vue-query";
import { trackAppFeature } from "@/analytics/app-analytics";
import APIClient from "@/APIClient";
import { QueryKey } from "./query-keys";
import UserState from "../UserState";

export const useGetMe = () =>
  useQuery({
    queryKey: [QueryKey.AUTH],
    queryFn: async () => {
      return await APIClient.getMe().then((user) => {
        UserState.updateAndPersist(user);
        return user;
      });
    },
    refetchInterval: 1000 * 60 * 5,
  });

export const useAddMember = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      name,
      role,
      email,
      password,
    }: {
      name: string;
      role: string;
      email: string;
      password: string;
    }) => {
      return await APIClient.addMember(name, role, email, password);
    },
    onSuccess: () => {
      trackAppFeature("member_invited");
      queryClient.invalidateQueries({
        queryKey: [QueryKey.USERS],
      });
    },
  });
};
